import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';

const { Option } = Select;

const AdminPartnerClassInput = ({
  name,
  disabled = false,
  label = null,
  isLoading,
  placeholder,
  defaultLimit,
  defaultOrder,
  filter = {},
  load,
  onChange,
  rules = null,
  style = null,
  allowNone = false,
  mode = 'multiple',
  options,
  ...props
}) => {
  // load tags on mount
  useEffect(() => {
    load(1, defaultLimit, defaultOrder, filter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          <Form.Item name={name} label={label} style={style} rules={rules}>
            <Select
              showSearch
              optionFilterProp='children'
              disabled={disabled}
              loading={isLoading}
              placeholder={placeholder || t('admin_partner_class_name')}
              mode={mode}
              maxTagCount={6}
            >
              {allowNone ? (
                <Select.Option key={0} value=''>
                  {t('form_input_options_none')}
                </Select.Option>
              ) : null}
              {options.map((x) => (
                <Option key={x.id} value={x.id}>
                  {x.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default AdminPartnerClassInput;
